import { render } from "./device-error-tooltip.vue?vue&type=template&id=283ba82e&ts=true"
import script from "./device-error-tooltip.vue?vue&type=script&lang=ts"
export * from "./device-error-tooltip.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__